import { createFileRoute, useParams } from '@tanstack/react-router'

import { FaceListScreen } from '@/components/growers/faces/face-list-screen'
import { useMyGrower } from '@/hooks/use-my-grower-query'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/my-grower/$growerId_/faces/',
)({
    component: MyGrowerFacesRoutePage,
})

/**
 * Danh sách khuôn mặt — surface HỘ TRỒNG tự vào.
 *
 * File đặt tên `.index.tsx` chứ không `faces.tsx` — xem lý do ở bản của nhân
 * viên: route cha không có <Outlet /> thì màn con không bao giờ render.
 *
 * Cùng component với màn nhân viên, chỉ khác scope: tài khoản hộ đi qua route
 * my-growers vì role `grower` cố ý không có growers.read.
 */
function MyGrowerFacesRoutePage() {
    const { growerId } = useParams({
        from: '/_app/_authed/_sidebar/agriculture/my-grower/$growerId_/faces/',
    })
    const { data: grower } = useMyGrower(growerId)

    return (
        <FaceListScreen
            growerId={growerId}
            growerName={grower?.name ?? ''}
            scope="my"
        />
    )
}
